import { BrowserRouter } from "react-router-dom";
import AppRoutes from "./Routes";
import "./styles/main.scss";
import ScrollToTop from "./components/ScollToTop";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
